module.exports = {
  title: '优势商品管理',
  route: {
    path: '/content-manage',
    children: {
      path: 'advantage-goods-manage',
    },
  },
};
